var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[(_vm.authenticated)?_c('v-btn',{attrs:{"color":"primary","fab":"","small":"","aria-label":"Go back"},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }